import React, { useEffect, useRef } from "react";
import { MdVerified } from "react-icons/md";
import { useAnimation, useInView, motion } from "framer-motion";

const Review = () => {
  const { innerWidth: Width } = window;
  const ref = useRef();
  const isInView = useInView(ref);
  const mainControlls = useAnimation();
  useEffect(() => {
    if (isInView) {
      mainControlls.start("visible");
    }
  }, [isInView, mainControlls]);
  return (
    <div className="overflow-x-hidden max-w-screen font-poppins">
      <section className="">
        {Width < 631 ? (
          <>
            <div className="container px-6 py-12 mx-auto">
              <div className="grid items-center gap-4 xl:grid-cols-5">
              <div className="max-w-2xl mx-auto rounded shadow-md bg-blue-100/10 p-6 my-8 space-y-4 text-center xl:col-span-2 xl:text-left">
                  <h2 className="text-4xl font-bold text-black">
                  FAQ
                  </h2>
                  <p className="text-black">
                  Voici nos services et ce que nous offrons !
                  </p>
                </div>
                <div className="p-6 xl:col-span-3">
                  <div className="grid gap-4 md:grid-cols-2">
                    <div className="grid content-center gap-4">
                      <div className="p-6 rounded shadow-md bg-blue-200/30">
                        <p>
                          Où trouver les Kits solaires certifiés de ETS ROSE : Tous nos produits sont disponibles dans notre dépôt situé à l’adresse : Province et commune, Kirundo centre, route Bugabira, quartier MUNANIRA. Aux agences de l’UCODE-MF (Kirundo & Muyinga) ; au point de vente devant la BCB KIRUNDO)
                        </p>
                        <div className="flex items-center mt-4 space-x-4">
                          <div className="flex">
                            <MdVerified
                              size={Width < 631 ? 35 : 40}
                              className="text-green-400 ml-2"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="p-6 rounded shadow-md bg-blue-200/60">
                        <p>
                          Les kits solaires de ETS ROSE sont-ils garantis de : À l'achat de nos kits solaires, vous disposez d'une garantie d'une durée de 24 mois.
                        </p>
                        <div className="flex items-center mt-4 space-x-4">
                          <div className="flex">
                            <MdVerified
                              size={Width < 631 ? 35 : 40}
                              className="text-green-400 ml-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid content-center gap-4">
                      <div className="p-6 rounded shadow-md bg-blue-200/60">
                        <p>
                          Quelle est la différence entre ces produits et celles qu’on trouve sur le marché : pour les nôtres, on donne garantie de 2 ans, ils sont certifiés VERASOL.
                        </p>
                        <div className="flex items-center mt-4 space-x-4">
                          <div className="flex">
                            <MdVerified
                              size={Width < 631 ? 35 : 40}
                              className="text-green-400 ml-2"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="p-6 rounded shadow-md bg-blue-200/30">
                        <p>
                          Où trouver les Kits solaires certifiés de ETS ROSE : Tous nos produits sont disponibles dans notre dépôt situé à l’adresse : Province et commune, Kirundo centre, route Bugabira, quartier MUNANIRA. Aux agences de l’UCODE-MF (Kirundo & Muyinga) ; au point de vente devant la BCB KIRUNDO)
                        </p>
                        <div className="flex items-center mt-4 space-x-4">
                          <div className="flex">
                            <MdVerified
                              size={Width < 631 ? 35 : 40}
                              className="text-green-400 ml-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="container px-6 py-12 mx-auto">
              <div className="grid items-center gap-4 xl:grid-cols-5">
                <motion.div
                  ref={ref}
                  variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1 },
                  }}
                  initial="hidden"
                  animate={mainControlls}
                  transition={{ duration: 0.5, delay: 0.25 }}
                  className="max-w-2xl mx-auto rounded shadow-md bg-blue-100/10 p-6 my-8 space-y-4 text-center xl:col-span-2 xl:text-left"
                >
                  <h2 className="text-4xl font-bold text-black">
                    FAQ
                  </h2>
                  <p className="text-black">
                  Voici nos services et ce que nous offrons !
                  </p>
                </motion.div>
                <div className="p-6 xl:col-span-3">
                  <div className="grid gap-4 md:grid-cols-2">
                    <div className="grid content-center gap-4">
                      <motion.div
                        ref={ref}
                        variants={{
                          hidden: { opacity: 0, x: -75, y: -45 },
                          visible: { opacity: 1, x: 0, y: 0 },
                        }}
                        initial="hidden"
                        animate={mainControlls}
                        transition={{ duration: 0.6, delay: 0.15 }}
                        className="p-6 rounded shadow-md bg-blue-200/30"
                      >
                        <p>
                          Où trouver les Kits solaires certifiés de ETS ROSE : Tous nos produits sont disponibles dans notre dépôt situé à l’adresse : Province et commune, Kirundo centre, route Bugabira, quartier MUNANIRA. Aux agences de l’UCODE-MF (Kirundo & Muyinga) ; au point de vente devant la BCB KIRUNDO)
                        </p>
                        <div className="flex justify-between items-center mt-4 space-x-4">
                          <div className="flex">
                            <MdVerified
                              size={Width < 631 ? 35 : 40}
                              className="text-green-400 ml-2"
                            />
                          </div>
                        </div>
                      </motion.div>
                      <motion.div
                        ref={ref}
                        variants={{
                          hidden: { opacity: 0, x: -75, y: 45 },
                          visible: { opacity: 1, x: 0, y: 0 },
                        }}
                        initial="hidden"
                        animate={mainControlls}
                        transition={{ duration: 0.6, delay: 0.35 }}
                        className="p-6 rounded shadow-md bg-blue-200/60"
                      >
                        <p>
                          Les kits solaires de ETS ROSE sont-ils garantis de : À l'achat de nos kits solaires, vous disposez d'une garantie d'une durée de 24 mois.
                        </p>
                        <div className="flex items-center justify-between mt-4 space-x-4">
                          <div className="flex">
                            <MdVerified
                              size={Width < 631 ? 35 : 40}
                              className="text-green-400 ml-2"
                            />
                          </div>
                        </div>
                      </motion.div>
                    </div>
                    <div className="grid content-center gap-4">
                      <motion.div
                        ref={ref}
                        variants={{
                          hidden: { opacity: 0, x: 75, y: -45 },
                          visible: { opacity: 1, x: 0, y: 0 },
                        }}
                        initial="hidden"
                        animate={mainControlls}
                        transition={{ duration: 0.7, delay: 0.55 }}
                        className="p-6 rounded shadow-md bg-blue-200/60"
                      >
                        <p>
                          Quelle est la différence entre ces produits et celles qu’on trouve sur le marché : pour les nôtres, on donne garantie de 2 ans, ils sont certifiés VERASOL.
                        </p>
                        <div className="flex justify-between items-center mt-4 space-x-4">
                          <div className="flex">
                            <MdVerified
                              size={Width < 631 ? 35 : 40}
                              className="text-green-400 ml-2"
                            />
                          </div>
                        </div>
                      </motion.div>
                      <motion.div
                        ref={ref}
                        variants={{
                          hidden: { opacity: 0, x: 75, y: 45 },
                          visible: { opacity: 1, x: 0, y: 0 },
                        }}
                        initial="hidden"
                        animate={mainControlls}
                        transition={{ duration: 0.8, delay: 0.75 }}
                        className="p-6 rounded shadow-md bg-blue-200/30"
                      >
                        <p>
                          Où trouver les Kits solaires certifiés de ETS ROSE : Tous nos produits sont disponibles dans notre dépôt situé à l’adresse : Province et commune, Kirundo centre, route Bugabira, quartier MUNANIRA. Aux agences de l’UCODE-MF (Kirundo & Muyinga) ; au point de vente devant la BCB KIRUNDO)
                        </p>
                        <div className="flex justify-between items-center mt-4 space-x-4">
                          <div className="flex">
                            <MdVerified
                              size={Width < 631 ? 35 : 40}
                              className="text-green-400 ml-2"
                            />
                          </div>
                        </div>
                      </motion.div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </section>
      <div className="w-[70%]  h-[2px] bg-gradient-to-r from-blue-400 to-violet-500"></div>
    </div>
  );
};

export default Review;
